import { CustomButton } from '@components/CustomButton'
import { useSetFilters } from '@hooks/filters'

export function ResetFilters() {
  const { mutateAsync: postSelectedFilters } = useSetFilters()

  function handleResetFilters() {
    postSelectedFilters({
      statusIds: [],
      areaIds: [],
      locationIds: [],
      supervisorIds: [],
      resourceIds: [],
      plantSectionIds: [],
      operationPostIds: [],
      assigneeIds: [],
      projectIds: [],
    })
  }

  return <CustomButton onPress={handleResetFilters}>Reset</CustomButton>
}
